'use client';

import { Box, Typography } from '@mui/material';
import MarketingInteriorLayout, {
  MARKETING_FORM_COLUMN_INNER_SX,
  MARKETING_FORM_COLUMN_SX,
  MARKETING_FORM_HERO_COLUMN_SX,
} from '@/components/home-landing/MarketingInteriorLayout';
import DesignStudioForm from '@/components/DesignStudioForm';
import { FORM_PAGE_DESKTOP_BP, heroTextLegibility } from './design-studio-glass';

const PAGE_COPY = {
  title: 'Join Our Design Studio',
  paragraphs: [
    "For two decades, NIICO has believed that the spaces we inhabit shape the lives we lead. We're looking for designers who share that conviction, people for whom precision is instinct and no detail is too small to matter.",
    'This is work for those who see a room not just as a space to be finished, but as a story to be told with rigor and quiet confidence. Join us and help build spaces worthy of a legacy.',
  ],
};

const DESIGN_STUDIO_FORM_GRID_SX = {
  width: '100%',
  maxWidth: { [FORM_PAGE_DESKTOP_BP]: 1200, xl: 1280 },
  mx: 'auto',
  px: { xs: 2, sm: 3, [FORM_PAGE_DESKTOP_BP]: 2, xl: 3 },
  gap: { xs: 4, [FORM_PAGE_DESKTOP_BP]: 3 },
};

export default function DesignStudioPage() {
  return (
    <MarketingInteriorLayout heroBackground formGrid formGridSx={DESIGN_STUDIO_FORM_GRID_SX}>
      <Box
        sx={{
          ...MARKETING_FORM_HERO_COLUMN_SX,
          textAlign: { xs: 'center', [FORM_PAGE_DESKTOP_BP]: 'left' },
        }}
      >
        <Typography
          component="h1"
          sx={{
            ...heroTextLegibility,
            fontWeight: 600,
            fontSize: {
              xs: 'clamp(1.75rem, 5vw, 2.5rem)',
              [FORM_PAGE_DESKTOP_BP]: '2.75rem',
              xl: '3.25rem',
            },
            lineHeight: 1.15,
            letterSpacing: '-0.02em',
            mb: { xs: 2, [FORM_PAGE_DESKTOP_BP]: 1.25 },
          }}
        >
          {PAGE_COPY.title}
        </Typography>
        {PAGE_COPY.paragraphs.map((paragraph, index) => (
          <Typography
            key={paragraph}
            component="p"
            sx={{
              ...heroTextLegibility,
              fontWeight: 400,
              fontSize: { xs: '1rem', [FORM_PAGE_DESKTOP_BP]: '1.0625rem' },
              lineHeight: { xs: 1.65, [FORM_PAGE_DESKTOP_BP]: 1.55 },
              maxWidth: { [FORM_PAGE_DESKTOP_BP]: 420, xl: 480 },
              mx: { xs: 'auto', [FORM_PAGE_DESKTOP_BP]: 0 },
              opacity: 0.95,
              mb: index < PAGE_COPY.paragraphs.length - 1 ? 2 : 0,
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>

      <Box sx={MARKETING_FORM_COLUMN_SX}>
        <Box sx={MARKETING_FORM_COLUMN_INNER_SX}>
          <DesignStudioForm variant="glass" />
        </Box>
      </Box>
    </MarketingInteriorLayout>
  );
}
